var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LayoutDefaultNew',[(_vm.isCreateDocumentVisible)?_c('div',[_c('CreateDocument',{key:_vm.refreshKeyCreateDocument})],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }